"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_LIST_MAX_NAME_LENGTH = exports.TOKEN_LIST_MIN_NAME_LENGTH = exports.LiFiBridge = exports.CrossChainServiceProvider = exports.ExchangeProviders = exports.TokenTypes = exports.TransactionAssetCategories = exports.TransactionDirections = exports.TransactionStatuses = void 0;
var TransactionStatuses;
(function (TransactionStatuses) {
    TransactionStatuses["Pending"] = "Pending";
    TransactionStatuses["Completed"] = "Completed";
    TransactionStatuses["Reverted"] = "Reverted";
})(TransactionStatuses = exports.TransactionStatuses || (exports.TransactionStatuses = {}));
var TransactionDirections;
(function (TransactionDirections) {
    TransactionDirections["Sender"] = "Sender";
    TransactionDirections["Receiver"] = "Receiver";
})(TransactionDirections = exports.TransactionDirections || (exports.TransactionDirections = {}));
var TransactionAssetCategories;
(function (TransactionAssetCategories) {
    TransactionAssetCategories["External"] = "external";
    TransactionAssetCategories["Internal"] = "internal";
    TransactionAssetCategories["Token"] = "token";
})(TransactionAssetCategories = exports.TransactionAssetCategories || (exports.TransactionAssetCategories = {}));
var TokenTypes;
(function (TokenTypes) {
    TokenTypes["Erc20"] = "Erc20";
    TokenTypes["Erc721"] = "Erc721";
    TokenTypes["Erc1155"] = "Erc1155";
    TokenTypes["Native"] = "Native";
    TokenTypes["WrappedSupertoken"] = "WrappedSupertoken";
})(TokenTypes = exports.TokenTypes || (exports.TokenTypes = {}));
var ExchangeProviders;
(function (ExchangeProviders) {
    ExchangeProviders["Uniswap"] = "Uniswap";
    ExchangeProviders["OneInch"] = "OneInch";
    ExchangeProviders["Synthetix"] = "Synthetix";
    ExchangeProviders["Sushiswap"] = "Sushiswap";
    ExchangeProviders["Honeyswap"] = "Honeyswap";
    ExchangeProviders["Paraswap"] = "Paraswap";
})(ExchangeProviders = exports.ExchangeProviders || (exports.ExchangeProviders = {}));
var CrossChainServiceProvider;
(function (CrossChainServiceProvider) {
    CrossChainServiceProvider["SocketV2"] = "SocketV2";
    CrossChainServiceProvider["LiFi"] = "LiFi";
    CrossChainServiceProvider["Etherspot"] = "Connext";
})(CrossChainServiceProvider = exports.CrossChainServiceProvider || (exports.CrossChainServiceProvider = {}));
var LiFiBridge;
(function (LiFiBridge) {
    LiFiBridge["across"] = "across";
    LiFiBridge["arbitrum"] = "arbitrum";
    LiFiBridge["avalanche"] = "avalanche";
    LiFiBridge["cbridge"] = "cbridge";
    LiFiBridge["connext"] = "connext";
    LiFiBridge["hop"] = "hop";
    LiFiBridge["hyphen"] = "hyphen";
    LiFiBridge["multichain"] = "multichain";
    LiFiBridge["optimism"] = "optimism";
    LiFiBridge["polygon"] = "polygon";
    LiFiBridge["stargate"] = "stargate";
})(LiFiBridge = exports.LiFiBridge || (exports.LiFiBridge = {}));
exports.TOKEN_LIST_MIN_NAME_LENGTH = 3;
exports.TOKEN_LIST_MAX_NAME_LENGTH = 32;
